import React, { useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import { GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import DescriptionIcon from "@mui/icons-material/Description";
import {
    Button,
    IconButton,
    Popper,
    TextField,
    Badge,
    MenuItem,
    Menu,
    Stack,
    Tooltip,
    Avatar,
    Tabs,
    Tab
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import Chip from "@mui/material/Chip";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../assets/images/image.png";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { DataGridPro } from "@mui/x-data-grid-pro";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
    getCompanyRfqMetaFilterData,
    getCustomerRfqData,
    getCustomerRfqDataV1
} from "../Services/OrgRepo";
import { CertificationDrawer } from "./CertificationDrawer";
import { Link, useNavigate } from "react-router-dom";
import {
    accountManager,
    accountManagerHead,
    NPDManagerHead,
    generateCompanyLogo,
    generatProfilePicUrl,
    getLoggedInEmail,
    getLoggedInUserID,
    isSourcingManagerHead,
    Management,
    productionManagerHead,
    qualityManagerHead,
    sourcingManager,
    sourcingManagerHead,
    formatCurrencyValue,
    getLoggedInName,
    getLoggedInUserDepartment,
    NPDManager,
    productionManager,
    proposalDownloadURL
} from "../../Utils/Constant";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EuroIcon from "@mui/icons-material/Euro";
import defaultlogo from "../../assets/icons/noimg.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import { useDispatch } from "react-redux";

import { setFips } from "crypto";
import { CertificationDrawerInReview } from "./CertificationDrawerInreview";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { getCURFQAssignedToMeFilterMetaFieldsApi } from "../Services/FeasibleRFQ";

export const DroppedRfq = () => {
    const [value, setValue] = React.useState("1");
    const [searchTerm, setSearchTerm] = useState("");
    const [rows, setRows] = useState<string[]>([]);
    const [filteredRows, setFilteredRows] = useState(rows);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);

    const [anchorEl, setAnchorEl] = useState(null);

    //filter states
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [selectedKeyAccountManager, setSelectedKeyAccountManager] = useState(
        []
    );
    const [selectedSourcingManager, setSelectedSourcingManager] = useState([]);

    const [filteredSelectedCompany, setFilteredSelectedCompany] = useState([]);
    const [
        filteredSelectedKeyAccountManager,
        setFilteredSelectedKeyAccountManager
    ] = useState([]);
    const [
        filteredSelectedSourcingManager,
        setFilteredSelectedSourcingManager
    ] = useState([]);
    const [isFilterLoading, setIsFilterLoading] = useState<boolean>(false);
    const [filterOptions, setFilterOptions] = useState<{
        [key: string]: { title: string; value: string }[];
    }>({});
    const [removeFilter, setRemoveFilter] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);

    const [isApplyFilter, setIsApplyFilter] = useState<Boolean>(false);

    const [readNew, setNewRead] = useState<Boolean>(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [maxWidth, setMaxWidth] =
        React.useState<DialogProps["maxWidth"]>("xs");
    const [isButtonDisable, setIsButtonDisable] = useState<boolean>(false);
    const [reasonForRejection, setReasonForRejection] = useState<string>("");
    const popperRef = useRef<HTMLDivElement>(null);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });

    /* Set the tab value state based on logged in user - start */
    const Department = ["Sourcing", "Production", "NPD"];
    let assignedDeptTab = null;
    // Setting the dept tab value based on logged in user if NPD or Production
    if (
        getLoggedInUserDepartment() === Department[2] ||
        getLoggedInUserDepartment() === Department[1]
    ) {
        assignedDeptTab = getLoggedInUserDepartment();
    } else {
        // Default the dept tab is Sourcing
        assignedDeptTab = Department[0];
    }
    const [tabValue, setTabValue] = React.useState(assignedDeptTab);

    type Option = {
        key: string;
        title: string;
    };

    type TeamMemberOptions = {
        sourcingTeamMembers: Option[];
        productionTeamMembers: Option[];
        npdTeamMembers: Option[];
    };

    const [sourcingTeamMembers, setSourcingTeamMembers] = useState();
    const [productionTeamMembers, setProductionTeamMembers] = useState();
    const [npdTeamMembers, setNpdTeamMembers] = useState();

    /* Set the tab value state based on logged in user - end */

    const navigate = useNavigate();

    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["rfqID", "rfqName"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setReasonForRejection("");
    };
    const dispath = useDispatch();

    const handleOpenDrawer = async (row: any) => {
        setSelectedRow(row);
        setOpenDrawer(true);
    };

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };

    /** Dropped tab changes  */
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
        setAnchorEl(null);
        handleClearAll();
        handleClearAllChip();
    };

    const fetchDroppedRfqData = async (params: string) => {
        setIsLoading(true);
        setNewRead(false);
        try {
            let paylod = {};

            paylod = {
                userEmail: getLoggedInEmail(),
                status: "RFQ Drop",
                department: tabValue
            };

            const response = await getCustomerRfqDataV1(paylod);
            setIsLoading(false);
            if (response?.status) {
                let data = response?.data?.map((item: any, index: number) => ({
                    id: index + 1, // DataGrid requires a unique `id` field
                    rfqID: item?.rfqID || `P${index + 1}`, // Generate an ID if missing
                    keyAccountManagerID: item?.keyAccountManagerID || "-",
                    key_account_manger_name: item?.key_account_manger_name,
                    key_account_manger_Id_logo:
                        item?.key_account_manger_Id_logo,
                    type_of_order: item?.type_of_order || "-",
                    assigneeName: item?.assigneeName || "Not Assigned",
                    totalOrderValue: item?.totalOrderValue || "-",
                    rfqName: item?.rfqName || "-",
                    assigneeProfilePath: item?.assigneeProfilePath,
                    assigneeEmail: item?.assigneeEmail,
                    assigneeId: item?.assigneeId || "-",
                    companyRecId: item?.companyRecId,
                    companyName: item?.companyName,
                    companyLogo: item?.companyLogo,
                    status: item?.status,
                    curfq_no: item?.curfq_no,
                    curfq_id: item?.curfq_id,
                    Proposal_File_Path: item?.Proposal_File_Path,
                    pricetype: item?.pricetype,
                    preferredCurrency: item?.preferredCurrency
                }));
                setRows(data);
                setFilteredRows(data);
            } else {
                setRows([]);
                setFilteredRows([]);
            }
        } catch (error) {
            setIsLoading(false);
            setRows([]);
            setFilteredRows([]);
        }
    };

    const [isInitialRender, setIsInitialRender] = useState(true);

    // filter useeffect and functions
    useEffect(() => {
        fetchDroppedRfqData(getLoggedInUserID());
        setAnchorEl(null);
        setSelectedCompany([]);
        setSelectedKeyAccountManager([]);
        // fetchdataInUseEffect();
    }, []);

    useEffect(() => {
        fetchDroppedRfqData(getLoggedInUserID());
    }, [tabValue]);

    const handleClearAll = () => {
        setSelectedCompany([]);
        setSelectedKeyAccountManager([]);
        setSelectedSourcingManager([]);
    };
    const handleClearAllChip = () => {
        setSelectedCompany([]);
        setSelectedKeyAccountManager([]);
        setSelectedSourcingManager([]);

        setFilteredSelectedCompany([]);
        setFilteredSelectedKeyAccountManager([]);
        setFilteredSelectedSourcingManager([]);

        setFilteredRows(rows);
        setIsApplyFilter(false);
    };
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (Object.keys(filterOptions).length === 0) {
            fetchFilterData();
        }
        //check the team member filter if the tab is switched to Sourcing
        if (tabValue === Department[0]) {
            setFilterOptions({
                teamMemberOptions: sourcingTeamMembers
            });
        } else if (tabValue === Department[1]) {
            //check the team member filter if the tab is switched to Production
            setFilterOptions({
                teamMemberOptions: productionTeamMembers
            });
        } else if (tabValue === Department[2]) {
            //check the team member filter if the tab is switched to NPD
            setFilterOptions({
                teamMemberOptions: npdTeamMembers
            });
        }
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedCompany(filteredSelectedCompany);
        setSelectedKeyAccountManager(filteredSelectedKeyAccountManager);
        setSelectedSourcingManager(filteredSelectedSourcingManager);
    };

    // Handle search input change
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);

        if (search?.length >= 3) {
            const filtered = rows?.filter((row) =>
                ["rfqID", "rfqName"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key].toLowerCase().includes(search.toLowerCase())
                )
            );
            setFilteredRows(filtered);
        } else {
            setFilteredRows(rows);
        }
    };

    const getFromValue = () => {
        if (sourcingManager() || sourcingManagerHead()) {
            return "DroppedRfq";
        }
        return "DroppedRfq";
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);

    const getCurrencyIcon = (currency) => {
        switch (currency) {
            case "INR":
                return <CurrencyRupeeIcon sx={{ fontSize: "0.875rem" }} />;
            case "USD":
                return <AttachMoneyIcon sx={{ fontSize: "0.875rem" }} />;
            case "EUR":
                return <EuroIcon sx={{ fontSize: "0.875rem" }} />;
            default:
                return null;
        }
    };

    const isHighValueRfq = (row) => {
        const { preferredCurrency, totalOrderValue } = row;

        return (
            (preferredCurrency === "INR" && totalOrderValue >= 5000000) ||
            (preferredCurrency === "EUR" && totalOrderValue >= 50000) ||
            (preferredCurrency === "USD" && totalOrderValue >= 50000)
        );
    };

    const columns: GridColDef[] = [
        {
            field: "rfqID",
            headerName: "CORFQ ID",
            width: 120,
            disableColumnMenu: true,
            renderCell: (params) => {
                const addedOnValue = params.row.addedOn
                    ? new Date(params.row.addedOn).getTime()
                    : 0;
                const nowValue = new Date().getTime();

                const hoursDiff = (nowValue - addedOnValue) / (1000 * 60 * 60);
                const daysExceeded = Math.floor(hoursDiff / 24);
                const status = params.row.status;
                const isKAMHead = accountManagerHead();
                const limitExceeded =
                    ((isKAMHead && status === "KAM Head Review Pending") ||
                        (!isKAMHead && status === "Pending")) &&
                    hoursDiff > 72;
                // console.log("limitExceeded", limitExceeded);
                const payload = {
                    rfqData: {
                        ID: params.row.curfq_id,
                        rfqID: params.row.curfq_no,
                        notificationID: params.row.notificationID,
                        isNew: params.row.isNew
                    },
                    from: "DroppedRfq"
                };
                return (
                    <>
                        <Link
                            to="/layout/CURFQDetails"
                            target="_blank"
                            state={{ payload }}
                            onClick={() => {
                                localStorage.setItem(
                                    "CURFQDetails",
                                    JSON.stringify(payload)
                                );
                            }}
                            style={{ textDecoration: "none" }}
                        >
                            {params?.value}
                        </Link>
                        {limitExceeded && (
                            <Tooltip
                                title={
                                    <>
                                        Waiting for Verdict for {daysExceeded}{" "}
                                        day
                                        {daysExceeded > 1 ? "s" : ""}
                                    </>
                                }
                            >
                                <ErrorOutlineOutlinedIcon
                                    color="error"
                                    sx={{ fontSize: "1rem", marginLeft: "5px" }}
                                />
                            </Tooltip>
                        )}
                    </>
                );
            }
        },
        {
            field: "rfqName",
            headerName: "CORFQ Name",
            width: 200,
            disableColumnMenu: true,
            cellClassName: (params) => {
                return isHighValueRfq(params?.row) ? "rfq-high-value-cell" : "";
            },
            renderCell: (params) => {
                const highValue = isHighValueRfq(params?.row);
                const payload = {
                    rfqData: {
                        ID: params.row.curfq_id,
                        rfqID: params.row.curfq_no,
                        notificationID: params.row.notificationID,
                        isNew: params.row.isNew
                    },
                    from: "DroppedRfq"
                };
                return (
                    <>
                        {highValue && (
                            <>
                                <div className="highlightChip">
                                    High value{" "}
                                    <TrendingUpIcon sx={{ fontSize: "1rem" }} />
                                </div>
                            </>
                        )}
                        <Link
                            to="/layout/CURFQDetails"
                            target="_blank"
                            // state={{ rfqData: params?.row }}
                            state={{ payload }}
                            onClick={() => {
                                localStorage.setItem(
                                    "CURFQDetails",
                                    JSON.stringify(payload)
                                );
                            }}
                            style={{
                                textDecoration: "none",
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center"
                            }}
                        >
                            <span>{params?.value}</span>
                            {!accountManager() && params.row.isNew && (
                                <CircleIcon
                                    sx={{ fontSize: "12px", color: " #1976d2" }}
                                />
                            )}
                        </Link>
                    </>
                );
            }
        },
        {
            field: "companyName",
            headerName: "Company Name",
            minWidth: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                const truncatedName = name;
                const logoUrl = params.row.companyLogo
                    ? generateCompanyLogo(
                          params.row.companyRecId,
                          params.row.companyLogo
                      )
                    : defaultlogo;
                const payload = {
                    companyRecId: params.row?.companyRecId,
                    compDetails: params.row,
                    from: getFromValue()
                };
                return (
                    <Link
                        to="/layout/CompanyProfilePage"
                        target="_blank"
                        state={{ payload }}
                        onClick={() => {
                            localStorage.setItem(
                                "CompanyProfilePage",
                                JSON.stringify(payload)
                            );
                        }}
                        style={{ textDecoration: "none" }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                // overflow: "hidden",
                                // textOverflow: "ellipsis",
                                // whiteSpace: "nowrap",
                                height: "100%",
                                cursor: "pointer"
                            }}
                        >
                            {logoUrl && (
                                <img
                                    src={logoUrl}
                                    alt={name}
                                    width={28}
                                    height={28}
                                    style={{
                                        borderRadius: "50%",
                                        border: "1px solid #D8D8D8"
                                    }}
                                />
                            )}
                            <Typography variant="body2" className="hoverClr">
                                {truncatedName}
                            </Typography>
                        </Box>
                    </Link>
                );
            }
        },
        {
            field: "totalOrderValue",
            headerName: "Total Order Value",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params.value;
                const currency = params?.row?.preferredCurrency;
                const formattedValue = formatCurrencyValue(value, currency);
                return (
                    <>
                        <div style={{ display: "block" }}>
                            <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                            >
                                {getCurrencyIcon(
                                    params?.row?.preferredCurrency
                                )}
                                <span style={{ paddingLeft: "5px" }}>
                                    {formattedValue}
                                </span>
                                <Tooltip title={params?.row?.pricetype}>
                                    <IconButton>
                                        <InfoOutlinedIcon
                                            style={{ fontSize: "16px" }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                            >
                                {params?.row?.preferredCurrency}
                            </Typography>
                        </div>
                    </>
                );
            }
        },
        ...(!accountManager()
            ? [
                  {
                      field: "key_account_manger_name",
                      headerName: "Key Account Manager",
                      width: 250,
                      disableColumnMenu: true,
                      renderCell: (params) => {
                          const name = params.value || "";
                          return (
                              <Grid
                                  container
                                  spacing={2}
                                  alignItems="center"
                                  width="100%"
                              >
                                  <Grid size={{ xs: 2, md: 2 }}>
                                      <img
                                          src={
                                              generatProfilePicUrl(
                                                  params.row
                                                      .keyAccountManagerID,
                                                  params.row
                                                      .key_account_manger_Id_logo,
                                                  "Profile_Picture"
                                              ) || ""
                                          }
                                          alt="KAM"
                                          width={28}
                                          height={28}
                                          style={{
                                              marginRight: "5px",
                                              borderRadius: "50%"
                                          }}
                                      />
                                  </Grid>
                                  <Grid size={{ xs: 10, md: 10 }}>
                                      <Typography variant="body2" className="">
                                          {name}
                                      </Typography>
                                  </Grid>
                              </Grid>
                          );
                      }
                  }
              ]
            : []),
        {
            field: "status",
            headerName: "MMRFQ Status",
            width: 170,
            disableColumnMenu: true,
            cellClassName: () => "first-pinned-right",
            headerClassName: "first-pinned-right",
            renderCell: (params) => {
                return (
                    <Chip
                        label={params?.row?.status}
                        variant="outlined"
                        size="small"
                        color={
                            params?.row?.status === "Internal RFQ Created"
                                ? "info"
                                : params?.row?.status === "Completed" ||
                                    params?.row?.status === "Partners Approved"
                                  ? "success"
                                  : params?.row?.status === "Quotes Received"
                                    ? "secondary"
                                    : "default"
                        }
                    />
                );
            }
        },
        ...(!sourcingManagerHead() ||
        !productionManagerHead() ||
        !NPDManagerHead()
            ? [
                  {
                      field: "assigneeName",
                      headerName: "Team Member",
                      width: 200,
                      disableColumnMenu: true,
                      cellClassName: () => "first-pinned-right",
                      headerClassName: "first-pinned-right",
                      renderCell: (params) => {
                          return (
                              <Grid
                                  container
                                  spacing={2}
                                  alignItems="center"
                                  width="100%"
                              >
                                  <Grid size={{ xs: 3, md: 3 }}>
                                      <Avatar
                                          src={
                                              generatProfilePicUrl(
                                                  params?.row?.assigneeID,
                                                  params?.row
                                                      ?.assigneeProfilePath,
                                                  "Profile_Picture"
                                              ) || ""
                                          }
                                          sx={{
                                              width: 28,
                                              height: 28,
                                              marginRight: 1
                                          }}
                                      />
                                  </Grid>
                                  <Grid size={{ xs: 9, md: 9 }}>
                                      <Typography variant="body2" className="">
                                          {params.value}
                                      </Typography>
                                  </Grid>
                              </Grid>
                          );
                      }
                  }
              ]
            : []),
        {
            field: "Proposal_File_Path",
            headerName: "Uploaded Proposal",
            width: 220,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params) => {
                const proposalPath = proposalDownloadURL(
                    params?.row?.Proposal_File_Path
                );

                if (!proposalPath) {
                    return (
                        <Chip
                            variant="outlined"
                            label="No Proposal Uploaded"
                            size="small"
                        />
                    );
                }

                return (
                    <Button
                        size="small"
                        startIcon={<DescriptionIcon fontSize="small" />}
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                                proposalPath,
                                "_blank",
                                "noopener,noreferrer"
                            );
                        }}
                    >
                        Proposal
                    </Button>
                );
            }
        },
        {
            field: "action",
            headerName: "Action",
            width: 70,
            disableColumnMenu: true,
            sortable: false,
            ...(!sourcingManagerHead() && {
                cellClassName: () => "first-pinned-right",
                headerClassName: "first-pinned-right"
            }),
            renderCell: (params) => <ActionMenu row={params.row} />
        }
    ];

    const ActionMenu = ({ row }) => {
        const visible =
            getLoggedInName() === row?.assigneeName &&
            row?.status === "Internal RFQ Not Created";
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = async (event: { currentTarget: any }) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <>
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem
                        sx={{ fontSize: "0.875rem" }}
                        disabled={row?.status === "Internal RFQ Not Created"}
                    >
                        <Link
                            to="/layout/AllMmrfq"
                            target="_blank"
                            style={{ textDecoration: "none" }}
                            state={{
                                rfqData: {
                                    ID: row?.curfq_id,
                                    rfqID: row?.curfq_no,
                                    notificationID: row?.notificationID,
                                    isNew: row?.isNew,
                                    assigneeName: row?.assigneeName
                                },
                                from: "DroppedRfq"
                            }}
                            onClick={() => {
                                localStorage.setItem(
                                    "AllMmrfq",
                                    JSON.stringify({
                                        rfqData: {
                                            ID: row?.curfq_id,
                                            rfqID: row?.curfq_no,
                                            notificationID: row?.notificationID,
                                            isNew: row?.isNew,
                                            assigneeName: row?.assigneeName
                                        },
                                        from: "DroppedRfq"
                                    })
                                );
                            }}
                        >
                            View MMRFQ
                        </Link>
                    </MenuItem>
                </Menu>
            </>
        );
    };

    const finalColumns = columns;

    const droppedCoRFQIndividualAccess =
        sourcingManager() ||
        sourcingManagerHead() ||
        NPDManagerHead() ||
        NPDManager() ||
        productionManagerHead() ||
        productionManager();

    /**Filter functionality**/
    /**Filter functionality start from here */
    function extractOptions(apiResponse: any[], keyName: string) {
        const section = apiResponse.find((item) => item[keyName]);
        if (!section) return [];

        // Handle keyAccountManager separately as it is a direct array
        if (Array.isArray(section[keyName])) {
            return section[keyName].map((name) => ({
                key: name,
                title: name
            }));
        }

        // Handle objects with choices
        if (section[keyName]?.choices) {
            return section[keyName].choices.map(
                (item: { key: any; link_name: any; value: any }) => ({
                    key: item.key || item.link_name || "unknown_key",
                    title: item.value || item.link_name || "Unknown"
                })
            );
        }

        return [];
    }

    const fetchFilterData = async () => {
        setIsFilterLoading(true);
        try {
            const filterData = await getCompanyRfqMetaFilterData();
            const filterDataStatus =
                await getCURFQAssignedToMeFilterMetaFieldsApi();
            if (filterData?.status) {
                type CompanyType = {
                    company: string[];
                };

                const companyDetails: string[] = Array.from(
                    new Set(rows?.map((item: any) => item?.companyName) ?? [])
                );

                const company: CompanyType[] = [{ company: companyDetails }];

                const apiResponse = filterData?.data;
                const companyOptions = extractOptions(company, "company");
                const keyAccountManagerOptions = extractOptions(
                    apiResponse,
                    "keyAccountManager"
                );

                /** Capture the department wise team members options for Filter - Start */
                setSourcingTeamMembers(
                    extractOptions(filterDataStatus?.data, "sourcing_managers")
                );

                setProductionTeamMembers(
                    extractOptions(
                        filterDataStatus?.data,
                        "production_managers"
                    )
                );

                setNpdTeamMembers(
                    extractOptions(filterDataStatus?.data, "npd_managers")
                );
                /** Capture the department wise team members options for Filter - End */

                const obj = {
                    companyOptions,
                    keyAccountManagerOptions,
                    teamMemberOptions: await extractOptions(
                        filterDataStatus?.data,
                        "sourcing_managers"
                    )
                };
                setFilterOptions(obj);
            }
            setIsFilterLoading(false);
        } catch (error) {
            setIsFilterLoading(false);
        }
    };

    const filterData = (
        rows: any[],
        filters: {
            key_account_manger_name: any;
            company: any;
            sourcingManager: any;
        }
    ) => {
        return rows?.filter(
            (row: {
                companyName: string;
                key_account_manger_name: string;
                assigneeName: string;
            }) => {
                // Convert row values to lowercase arrays for comparison
                const companyArray =
                    row?.companyName?.toLowerCase()?.split(/\s*,\s*/) || [];
                const keyAccountManagerArray =
                    row?.key_account_manger_name
                        ?.toLowerCase()
                        ?.split(/\s*,\s*/) || [];
                const sourcingManagerArray =
                    row?.assigneeName?.toLowerCase()?.split(/\s*,\s*/) || [];

                // Get filter values, ignore empty ones
                const {
                    company = [],
                    key_account_manger_name = [],
                    sourcingManager = []
                } = filters;

                // Check if each applied filter matches
                const companyMatch =
                    company?.length === 0 ||
                    company?.some((cert: string) =>
                        companyArray?.includes(cert.toLowerCase())
                    );

                const keyAccounManagerMatch =
                    key_account_manger_name?.length === 0 ||
                    key_account_manger_name?.some((loc: string) =>
                        keyAccountManagerArray.includes(loc.toLowerCase())
                    );
                const sourcingManagerMatch =
                    sourcingManager?.length === 0 ||
                    sourcingManager?.some((loc: string) =>
                        sourcingManagerArray.includes(loc.toLowerCase())
                    );

                // **Must match ALL applied filters**
                return (
                    companyMatch &&
                    keyAccounManagerMatch &&
                    sourcingManagerMatch
                );
            }
        );
    };

    const handleApply = async () => {
        setIsApplyFilter(true);
        let filters = {
            key_account_manger_name:
                selectedKeyAccountManager?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            company:
                selectedCompany?.map((item) => item?.title.toLowerCase()) || [],
            sourcingManager:
                selectedSourcingManager?.map((item) =>
                    item?.title?.toLowerCase()
                ) || []
        };

        const filteredResults = filterData(rows, filters);
        setFilteredRows(filteredResults);
        setAnchorEl(null);
        setFilteredSelectedCompany(selectedCompany);
        setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
        setFilteredSelectedSourcingManager(selectedSourcingManager);

        if (
            selectedKeyAccountManager?.length == 0 &&
            selectedCompany?.length === 0 &&
            selectedSourcingManager?.length === 0
        ) {
            setFilteredRows(rows);
            setFilteredSelectedCompany(selectedCompany);
            setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
            setFilteredSelectedSourcingManager(selectedSourcingManager);
        }
    };

    const handleRemoveFilter = (category: string, item: { title: any }) => {
        if (removeFilter == true) {
            setRemoveFilter(false);
        } else {
            setRemoveFilter(true);
        }
        switch (category) {
            case "company":
                setSelectedCompany((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "key_account_manger_name":
                setSelectedKeyAccountManager((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "sourcingManager":
                setSelectedSourcingManager((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            default:
                break;
        }
    };

    // Run `handleApply` after any filter changes
    useEffect(() => {
        handleApply();
        if (
            selectedKeyAccountManager?.length == 0 &&
            selectedCompany?.length === 0 &&
            selectedSourcingManager?.length === 0
        ) {
            setIsApplyFilter(false);
        }
    }, [removeFilter]);

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            Dropped CORFQ
                        </Typography>
                    </>
                ]}
            </Breadcrumbs>

            {droppedCoRFQIndividualAccess ? (
                <Typography variant="h5" mb={1}>
                    Dropped CORFQ
                </Typography>
            ) : (
                <>
                    <Typography variant="h5" mb={1}>
                        Dropped CORFQ
                    </Typography>
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        textColor="primary"
                        indicatorColor="primary"
                        aria-label="secondary tabs example"
                        sx={{
                            "& .MuiTab-root": {
                                textTransform: "none"
                            }
                        }}
                    >
                        <Tab value="Sourcing" label="Sourcing CORFQs" />
                        <Tab value="Production" label="Production CORFQs" />
                        <Tab value="NPD" label="NPD CORFQs" />
                    </Tabs>
                </>
            )}

            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        {rows?.length > 1 && (
                            <Grid container spacing={2}>
                                {/* Search Section */}
                                <Grid size={{ xs: 12, md: 7 }}>
                                    <TextField
                                        label="Search by CORFQ ID & CORFQ Name"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        inputRef={searchInputRef}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </Grid>
                                {/* Filter section */}
                                <Grid
                                    size={{ xs: 12, md: 5 }}
                                    sx={{
                                        color: "grey",
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <Box>
                                        <IconButton onClick={handleClick}>
                                            <Badge
                                                badgeContent={
                                                    filteredSelectedKeyAccountManager?.length +
                                                    filteredSelectedCompany?.length +
                                                    filteredSelectedSourcingManager?.length
                                                }
                                                color="primary"
                                            >
                                                <FilterAltOutlinedIcon />
                                            </Badge>
                                        </IconButton>

                                        <Popper
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            placement="bottom-start"
                                            sx={{ zIndex: 13 }}
                                        >
                                            <Paper
                                                ref={popperRef}
                                                sx={{
                                                    p: 2,
                                                    width: 350,
                                                    boxShadow: 3,
                                                    borderRadius: 2
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        fontWeight: "bold",
                                                        mb: 2,
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between"
                                                    }}
                                                >
                                                    Filter{" "}
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        onClick={handleClearAll}
                                                    >
                                                        CLEAR ALL
                                                    </Button>
                                                </Box>
                                                {!isFilterLoading ? (
                                                    <Box sx={{ mb: 2 }}>
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.companyOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            value={
                                                                selectedCompany
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedCompany(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            //  disabled={(selectedIndustry || []).length == 0}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Company"
                                                                    placeholder="Select Company"
                                                                />
                                                            )}
                                                        />

                                                        {!accountManager() && (
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                options={[
                                                                    ...(filterOptions?.keyAccountManagerOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedKeyAccountManager
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedKeyAccountManager(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Key Account Manager"
                                                                        placeholder="Select Key Account Manager"
                                                                    />
                                                                )}
                                                            />
                                                        )}
                                                        <Autocomplete
                                                            multiple
                                                            limitTags={2}
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            size="small"
                                                            id="multiple-limit-tags"
                                                            value={
                                                                selectedSourcingManager
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedSourcingManager(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            options={[
                                                                ...(filterOptions?.teamMemberOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            renderOption={(
                                                                props,
                                                                option
                                                            ) => (
                                                                <li
                                                                    {...props}
                                                                    style={{
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        gap: 10
                                                                    }}
                                                                >
                                                                    <Typography>
                                                                        {
                                                                            option.title
                                                                        }
                                                                    </Typography>
                                                                </li>
                                                            )}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Team Member"
                                                                    placeholder="Select Team Member"
                                                                />
                                                            )}
                                                        />
                                                    </Box>
                                                ) : (
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="50vh"
                                                    >
                                                        <ThreeDot
                                                            color="#1976d2"
                                                            size="medium"
                                                            text=""
                                                            textColor=""
                                                        />
                                                    </Box>
                                                )}
                                                {/* Apply / Cancel Buttons */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        mt: 2
                                                    }}
                                                >
                                                    <Button
                                                        onClick={handleClose}
                                                        color="error"
                                                    >
                                                        CANCEL
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleApply}
                                                    >
                                                        APPLY
                                                    </Button>
                                                </Box>
                                            </Paper>
                                        </Popper>
                                    </Box>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        {value === "1" && selectedRows?.length > 0 && (
                            <>
                                <div style={{ float: "right" }}>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        disabled={isButtonDisable}
                                        onClick={handleClickOpenDialog}
                                        sx={{ marginRight: "10px" }}
                                    >
                                        Reject
                                    </Button>
                                    <Dialog
                                        open={openDialog}
                                        onClose={handleCloseDialog}
                                        maxWidth={maxWidth}
                                        fullWidth
                                        aria-labelledby="responsive-dialog-title"
                                    >
                                        <DialogTitle id="responsive-dialog-title">
                                            {"Reason for Rejection"}
                                        </DialogTitle>
                                        <div style={{ padding: "0 20px" }}>
                                            <TextField
                                                id="outlined-multiline-static"
                                                label="Add your comments"
                                                multiline
                                                rows={4}
                                                value={reasonForRejection}
                                                onChange={(e) =>
                                                    setReasonForRejection(
                                                        e?.target?.value
                                                    )
                                                }
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                fullWidth
                                            />
                                        </div>
                                        <DialogActions>
                                            <Button
                                                autoFocus
                                                color="error"
                                                onClick={handleCloseDialog}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                disabled={
                                                    reasonForRejection?.length <=
                                                    0
                                                }
                                                autoFocus
                                            >
                                                Submit
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        disabled={isButtonDisable}
                                    >
                                        Accept
                                    </Button>
                                </div>
                            </>
                        )}
                    </Grid>
                    {/* filter chip section */}
                    <Grid size={{ xs: 12, md: 12 }}>
                        {/* Selected Filters as Chips */}
                        {isApplyFilter == true && (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1
                                }}
                                mb={2}
                            >
                                {filteredSelectedCompany?.map((item, index) => (
                                    <Chip
                                        key={`company-${index}`}
                                        label={item?.title}
                                        onDelete={() =>
                                            handleRemoveFilter("company", item)
                                        }
                                        size="small"
                                    />
                                ))}

                                {filteredSelectedKeyAccountManager?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`keyAccountManager-${index}`}
                                            label={item.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "keyAccountManager",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}

                                {filteredSelectedSourcingManager?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`sourcingManager-${index}`}
                                            label={item.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "sourcingManager",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}
                                {/* Clear All Button - Show only when filters exist */}
                                {filteredSelectedKeyAccountManager?.length +
                                    filteredSelectedCompany?.length +
                                    filteredSelectedSourcingManager?.length >
                                    0 && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={handleClearAllChip}
                                        sx={{
                                            fontSize: ".75rem !important",
                                            lineHeight: "1",
                                            borderRadius: "30px"
                                        }}
                                    >
                                        CLEAR ALL
                                    </Button>
                                )}
                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Paper
                    sx={{
                        // height: 400,
                        height:
                            filteredRows?.length > 4
                                ? "62vh"
                                : filteredRows?.length > 0
                                  ? "auto"
                                  : "62vh",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    {!isLoading ? (
                        filteredRows?.length > 0 ? (
                            <DataGridPro
                                // autoHeight
                                pinnedColumns={pinnedColumns}
                                onPinnedColumnsChange={
                                    handlePinnedColumnsChange
                                }
                                getRowHeight={() => "auto"}
                                rows={filteredRows}
                                columns={finalColumns}
                                pagination={filteredRows?.length > 10}
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                                pageSizeOptions={[10, 20]}
                                disableRowSelectionOnClick={true}
                                columnVisibilityModel={{
                                    lastUpdateOn:
                                        accountManager() ||
                                        accountManagerHead() ||
                                        Management()
                                }}
                                initialState={{
                                    sorting: {
                                        sortModel: [
                                            {
                                                field: "lastUpdateOn",
                                                sort: "desc"
                                            }
                                        ]
                                    }
                                }}
                                sx={{
                                    width: "100%",
                                    "& .MuiDataGrid-columnHeaderTitleContainer":
                                        {
                                            "& .MuiDataGrid-sortIcon": {
                                                opacity: "1 !important",
                                                visibility: "visible !important"
                                            }
                                        },
                                    "& .MuiDataGrid-cell": {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                        {
                                            backgroundColor: "#F4F4F4!important"
                                        }
                                }}
                            />
                        ) : (
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "20px"
                                    }}
                                >
                                    {(searchTerm &&
                                        filteredRows?.length == 0) ||
                                    (isApplyFilter &&
                                        filteredRows?.length == 0) ? (
                                        "No Options available"
                                    ) : (
                                        <>
                                            <img
                                                src={emptyImage}
                                                alt="Empty"
                                                width={"300px"}
                                            />
                                            <b style={{ color: "#0009" }}>
                                                No CORFQs Captured yet
                                            </b>
                                        </>
                                    )}
                                </div>
                            </>
                        )
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                        >
                            <ThreeDot
                                color=" #1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Paper>
                <CertificationDrawerInReview
                    open={openDrawer}
                    onClose={handleCloseDrawer}
                    selectedPartner={selectedRow}
                />
            </Box>
        </>
    );
};
